module.exports = __webpack_public_path__ + "static/axo_freiraume-5302d41995c2c2fe3ad9f50cce107b7c.png";